import React from 'react';
import Modal from 'react-bootstrap4-modal';

const CustomModal = (props) => {
    let { details, confirmBtn, cancelBtn, crossBtn, enableBackDrop, modalType, modalHeader, showBtns, modalSize, noOverFLow } = props
    let __style = `modal-content rounded-1 dark-theme ${(modalType === "danger") ? "border-light" : "border-light"}`
    let __style2 = `modal-header rounded-0 dark-theme ${(modalHeader === "danger") ? "bg-danger" : "bg-white"}`
    let __modalSize = `${(modalSize === "large") ? "modal-lg" : ''}`
    let __noOverFlow = noOverFLow ? 'hidden' : 'auto'

    return (
        <Modal dialogClassName={__modalSize} visible={props.visibility} onClickBackdrop={enableBackDrop ? cancelBtn.action : null}>
            <div className={__style} style={{border:'1px solid rgba(0,0,0,.2)'}}>
                <div style={{borderBottom:'1px solid #e9ecef'}} className={__style2}>
                    <h5 style={{fontWeight:'700',fontSize:'24px'}} className="modal-title ">{details.info}</h5>
                    <button type="button create_project_btn_close " className="close close-button" onClick={crossBtn.action}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div  style={{borderBottom:'1px solid #e9ecef', maxHeight:'51.7em', overflowY:__noOverFlow}} className="modal-body">
                    {details.msg}
                </div>
                {
                (showBtns) ?
                    <div className="modal-footer">
                        <button type="button" className={modalType === "danger" ? "btn btn-danger" : "btn btn-theme"} onClick={confirmBtn.action}>{confirmBtn.label}</button>
                        <button type="button" className="btn btn-theme-cancel" onClick={cancelBtn.action}>{cancelBtn.label}</button>
                    </div>
                    : ""
            }
            </div>
           
        </Modal>
    )
}
export default CustomModal

CustomModal.defaultProps = {
    modalType: 'confirmation',
    visibility: true,
    showBtns: true,
    enableBackDrop: true,
    details: {
        info: 'N/A',
        msg: 'N/A'
    },
    crossBtn: {
        action: null
    },
    confirmBtn: {
        label: 'Confirm',
        action: null
    },
    cancelBtn: {
        label: 'Cancel',
        action: null
    }


}